import { useEffect } from "react";

// Reloads stale tabs onto the newest deploy. Compares the main bundle in the live
// index.html with the one this tab is running; never reloads mid-countdown/race.
const CHECK_MS = 60000;
const BUNDLE_RE = /\/static\/js\/main\.[a-z0-9]+\.js/;

const runningBundle = () =>
  [...document.scripts].map((s) => s.src.match(BUNDLE_RE)?.[0]).find(Boolean) || null;

const inRace = () => document.body.classList.contains("immersive-race");

export function useAutoUpdate(pathname) {
  useEffect(() => {
    const mine = runningBundle();
    if (!mine) return undefined;   // dev server - nothing to compare
    let stale = false;
    const check = async () => {
      if (!stale) {
        try {
          const html = await (await fetch(`/?v=${Date.now()}`, { cache: "no-store" })).text();
          const live = html.match(BUNDLE_RE)?.[0];
          stale = !!live && live !== mine;
        } catch { return; }
      }
      if (stale && !inRace()) window.location.reload();
    };
    check();
    const t = setInterval(check, CHECK_MS);
    const onVis = () => document.visibilityState === "visible" && check();
    document.addEventListener("visibilitychange", onVis);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", onVis); };
  }, [pathname]);
}
